import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import Loader from "react-loader-spinner";
import Cookies from 'universal-cookie';
import { FaArrowLeft, FaCreditCard, FaCalendar, FaFile, FaGraduationCap } from "react-icons/fa";
import { GrTransaction } from "react-icons/gr";
import Header from '../Components/Header';
import * as Constant from '../Constant';
import { css } from '@emotion/core';
import ClipLoader from "react-spinners/ClipLoader";
import './rekapsantri.css';

const DetailRekap = ({ match }) => {
    const [selectedSantri, setSelectedSantri] = useState({
        total_tagihan: 0,
        sudah_terbayar: 0,
        periode: [],
    });
    const [statusBerhasil, setStatusBerhasil] = useState({ values: [], title: "Berhasil" });
    const [statusPending, setStatusPending] = useState({ values: [], title: "Pending" });
    const [statusGagal, setStatusGagal] = useState({ values: [], title: "Gagal" });
    const [filter, setFilter] = useState('');
    const [paymentTypeFilter, setPaymentTypeFilter] = useState('');
    const [loading, setLoading] = useState(true);
    const [isSubmittingPendaftaran, setIsSubmittingPendaftaran] = useState(false);
    const [isSubmittingSPP, setIsSubmittingSPP] = useState(false);
    const [isSubmittingTahunan, setIsSubmittingTahunan] = useState(false);
    const [goHome, setGoHome] = useState(false);
    const cookies = new Cookies();
    const accessToken = cookies.get('accessToken');
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: #ea6123 solid 4px;
    `;

    useEffect(() => {
        const { id } = match.params;
        fetchSantriDetail(id);
        fetchStatusParameters();
    }, [match.params]);

    const fetchStatusParameters = async () => {
        try {
            const statusKeys = ['status_berhasil', 'status_pending', 'status_gagal'];
            const responses = await Promise.all(
                statusKeys.map(key => fetch(`${Constant.GET_PARAMETER}${key}`).then(res => res.json()))
            );

            setStatusBerhasil({
                values: responses[0].data.value.split(','),
                title: responses[0].data.judul
            });

            setStatusPending({
                values: responses[1].data.value.split(','),
                title: responses[1].data.judul
            });

            setStatusGagal({
                values: responses[2].data.value.split(','),
                title: responses[2].data.judul
            });
        } catch (error) {
            console.error("Error fetching status parameters:", error);
        }
    };

    const fetchSantriDetail = (id) => {
        axios.get(`${Constant.BASE_URL}/api/santri/${id}`, {
            headers: { Authorization: accessToken }
        })
            .then((response) => {
                setSelectedSantri(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching santri detail:', error);
                setLoading(false);
            });
    };

    const getStatusTitle = (status) => {
        if (statusBerhasil.values.includes(status)) return statusBerhasil.title;
        if (statusPending.values.includes(status)) return statusPending.title;
        if (statusGagal.values.includes(status)) return statusGagal.title;
        return "Tidak Diketahui";
    };

    const findPaymentId = (type) => {
        if (selectedSantri.pembayaran && selectedSantri.pembayaran[type]) {
            switch (type) {
                case 'pendaftaran':
                    return selectedSantri.pendaftaran_id;
                case 'spp':
                    return selectedSantri.spp_id;
                case 'tahunan':
                    return selectedSantri.tahunan_id;
                default:
                    return null;
            }
        }
        return null;
    };

    const handleNavigation = async (type) => {
        // Mapping state setter berdasarkan tipe pembayaran
        const setLoadingState = {
            pendaftaran: setIsSubmittingPendaftaran,
            spp: setIsSubmittingSPP,
            tahunan: setIsSubmittingTahunan,
        };

        setLoadingState[type](true); // Aktifkan loading untuk tombol yang sesuai
        try {
            const paymentEndpoints = {
                pendaftaran: Constant.GENERATE_PENDAFTARAN_LINK,
                spp: Constant.GENERATE_SPP_LINK,
                tahunan: Constant.GENERATE_TAHUNAN_LINK,
            };

            const paymentId = findPaymentId(type);
            if (!paymentId) {
                alert(`Tidak ada tagihan ${type.toUpperCase()} yang tersedia`);
                return;
            }

            const response = await trackPromise(
                axios.post(
                    paymentEndpoints[type],
                    { id: paymentId },
                    {
                        headers: { Authorization: accessToken },
                    }
                )
            );

            const { encoded_data } = response.data;
            window.location.href = `/pembayaran/${type}/${encoded_data}`;
        } catch (error) {
            console.error("Error generating payment link:", error);
            alert("Gagal membuat link pembayaran");
        } finally {
            setLoadingState[type](false); // Matikan loading untuk tombol yang sesuai
        }
    };

    const getRelativeDateLabel = (dateString) => {
        const dateObj = new Date(dateString);
        const today = new Date();

        // Atur waktu ke 00:00:00 untuk membandingkan hanya tanggalnya
        today.setHours(0, 0, 0, 0);
        dateObj.setHours(0, 0, 0, 0);

        // Hitung selisih hari
        const diffTime = today - dateObj;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 0) return "Hari ini";
        if (diffDays === 1) return "Kemarin";
        if (diffDays === 2) return "2 hari lalu";

        // Format tanggal (misal: "27 Januari")
        return new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "long" }).format(dateObj);
    };


    const formatRupiah = (nominal) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
        }).format(nominal);
    };

    const filteredPayments = selectedSantri.pembayaran
        ? Object.keys(selectedSantri.pembayaran)
            .flatMap((key) =>
                selectedSantri.pembayaran[key].map((pembayaran) => ({
                    tipe: key,
                    tanggal: pembayaran.updated_at.split('T')[0],
                    nominal: pembayaran.nominal,
                    status: pembayaran.status,
                    tahun_ajaran: pembayaran.tahun_ajaran,
                    updated_at: pembayaran.updated_at,
                    statusTitle: getStatusTitle(pembayaran.status),
                }))
            )
            .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
            .filter((pembayaran) => {
                if (filter !== '') {
                    const startYear = parseInt(filter, 10);
                    const endYear = startYear + 1;
                    const [filterStart, filterEnd] = pembayaran.tahun_ajaran.split('/').map((year) => parseInt(year, 10));
                    if (startYear !== filterStart || endYear !== filterEnd) return false;
                }
                if (paymentTypeFilter !== '' && pembayaran.tipe !== paymentTypeFilter) {
                    return false;
                }
                return true;
            })
        : [];

    const tunggakan = selectedSantri.total_tagihan - selectedSantri.sudah_terbayar;
    const progress = selectedSantri.total_tagihan > 0
        ? parseFloat(((selectedSantri.sudah_terbayar / selectedSantri.total_tagihan) * 100).toFixed(2))
        : 0;

    if (goHome) return <Redirect exact to='/rekap-santri' />;

    const groupedPayments = {};
    filteredPayments.forEach((payment) => {
        const label = getRelativeDateLabel(payment.updated_at);
        if (!groupedPayments[label]) {
            groupedPayments[label] = [];
        }
        groupedPayments[label].push(payment);
    });
    return (
        <div style={{ backgroundColor: '#f4f4f4', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>
            {/* Header with Profile */}
                    <Header />
            {loading ? (
                <div className="loading-container">
                    <ClipLoader css={override} size={150} color={"#ea6123"} loading={loading} />
                </div>
            ) : (
                <>
                    <header style={{
                        backgroundColor: 'white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        padding: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        zIndex: '9999',
                        position: 'relative',

                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FaArrowLeft
                                onClick={() => setGoHome(true)}
                                style={{
                                    marginRight: '1rem',
                                    cursor: 'pointer',
                                    color: '#333'
                                }}
                            />
                            <img
                                src={selectedSantri.foto || '/profile-default.png'}
                                alt="Foto Santri"
                                style={{
                                    width: '3rem',
                                    height: '3rem',
                                    borderRadius: '50%',
                                    marginRight: '1rem',
                                    objectFit: 'cover'
                                }}
                            />
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'start',
                            }}>

                                <h2 style={{
                                    fontSize: '1.25rem',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    alignItems: 'center',
                                }}>
                                    {selectedSantri.full_name || 'Nama Tidak Tersedia'}
                                </h2>
                                <h3
                                    style={{
                                        fontSize: '0.9rem',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        alignItems: 'center',
                                    }}
                                >
                                    {(Array.isArray(selectedSantri.periode) && selectedSantri.periode.length > 0
                                        ? selectedSantri.periode[0].split('/')[0]
                                        : 'Periode Tidak Tersedia') + ' - Sekarang'}
                                </h3>
                            </div>

                        </div>
                    </header>
                    <div style={{ display: 'flex', padding: '1rem', paddingBottom: '0', justifyContent: 'center', alignItems: 'center' }}>
                        <h6 style={{
                            fontSize: '1.25rem',
                            fontWeight: '700',
                            color: '#333',
                            marginBottom: '0.5rem',
                            justifyContent: 'center'
                        }}>
                            Bayar
                        </h6>
                    </div>
                    <div style={{ display: 'flex', gap: '1rem', marginTop: '0', marginLeft: '1rem', marginRight: '1rem', justifyContent: 'center' }}>
                        <button
                            onClick={() => handleNavigation("pendaftaran")}
                            style={{
                                width: "90%",
                                padding: "0.4rem",
                                borderRadius: "0.4rem",
                                backgroundColor: "#2786FB",
                                color: "white",
                                border: "none",
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem",
                            }}
                            disabled={isSubmittingPendaftaran} // Nonaktifkan tombol saat loading
                        >
                            {isSubmittingPendaftaran && <Loader type="ThreeDots" color="white" height={20} width={20} />}
                            {!isSubmittingPendaftaran && "Pendaftaran"}
                        </button>

                        <button
                            onClick={() => handleNavigation("spp")}
                            style={{
                                width: "90%",
                                padding: "0.4rem",
                                borderRadius: "0.4rem",
                                backgroundColor: "#1DC9B7",
                                color: "white",
                                border: "none",
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem",
                            }}
                            disabled={isSubmittingSPP} // Nonaktifkan tombol saat loading
                        >
                            {isSubmittingSPP && <Loader type="ThreeDots" color="white" height={20} width={20} />}
                            {!isSubmittingSPP && "SPP"}
                        </button>

                        <button
                            onClick={() => handleNavigation("tahunan")}
                            style={{
                                width: "90%",
                                padding: "0.4rem",
                                borderRadius: "0.4rem",
                                backgroundColor: "#FD27EB",
                                color: "white",
                                border: "none",
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem",
                            }}
                            disabled={isSubmittingTahunan} // Nonaktifkan tombol saat loading
                        >
                            {isSubmittingTahunan && <Loader type="ThreeDots" color="white" height={20} width={20} />}
                            {!isSubmittingTahunan && "Tahunan"}
                        </button>
                    </div>


                    {/* Progress Bar */}
                    <div style={{ padding: '1rem' }}>
                        <h6 style={{
                            fontSize: '1.25rem',
                            fontWeight: '700',
                            color: '#333',
                            marginBottom: '0.5rem',
                            display: 'flex',
                            justifyContent: 'center',
                        }}>
                            Progress
                        </h6>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '0.5rem',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            padding: '1.2rem'
                        }}>
                            <div style={{ marginBottom: '0.5rem' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: '1rem',
                                    color: '#666'
                                }}>
                                    <span>{formatRupiah(selectedSantri.sudah_terbayar || 0)}</span>
                                    <span>{formatRupiah(selectedSantri.total_tagihan || 0)}</span>
                                </div>
                                <div style={{
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '9999px',
                                    height: '1rem'
                                }}>
                                    <div style={{
                                        backgroundColor: '#EA6022',
                                        borderRadius: '9999px',
                                        height: '1rem',
                                        width: `${progress}%`
                                    }}></div>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: '0.75rem',
                                    color: '#999',
                                    marginTop: '0.25rem'
                                }}>
                                    <span>Terbayar</span>
                                    <span>Total Tagihan</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Payment History */}
                    <div style={{ padding: '1rem', paddingTop: '0' }}>
                        <h6 style={{
                            fontSize: '1.25rem',
                            fontWeight: '700',
                            color: '#333',
                            marginBottom: '0.5rem',
                            display: 'flex',
                            justifyContent: 'center',
                        }}>
                            History Pembayaran
                        </h6>
                        {/* Filters */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '1rem',
                            padding: '1rem',
                            paddingTop: '0'
                        }}>
                            <select
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                style={{
                                    padding: '0.5rem 1rem',
                                    border: '1px solid #ccc',
                                    borderRadius: '0.5rem',
                                    fontSize: '0.875rem'
                                }}
                            >
                                <option value="">Tahun Ajaran</option>
                                {selectedSantri.periode?.map((tahunAjaran) => (
                                    <option key={tahunAjaran} value={tahunAjaran.split('/')[0]}>
                                        {tahunAjaran}
                                    </option>
                                ))}
                            </select>
                            <select
                                value={paymentTypeFilter}
                                onChange={(e) => setPaymentTypeFilter(e.target.value)}
                                style={{
                                    padding: '0.5rem 1rem',
                                    border: '1px solid #ccc',
                                    borderRadius: '0.5rem',
                                    fontSize: '0.875rem'
                                }}
                            >
                                <option value="">Jenis Pembayaran</option>
                                <option value="pendaftaran">Pendaftaran</option>
                                <option value="spp">SPP</option>
                                <option value="tahunan">Tahunan</option>
                            </select>
                        </div>
                        {Object.keys(groupedPayments).length > 0 ? (
                            Object.entries(groupedPayments).map(([label, payments]) => (
                                <div key={label} style={{ marginBottom: "1rem" }}>
                                    {/* Label kategori tanggal */}
                                    <h3 style={{
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        color: "#333",
                                        marginBottom: "0.5rem",
                                    }}>
                                        {label}
                                    </h3>

                                    {/* Data pembayaran berdasarkan kategori */}
                                    {payments.map((payment, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                backgroundColor: "white",
                                                borderRadius: "0.5rem",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                padding: "1rem",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "0.75rem",
                                            }}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginBottom: "0.5rem",
                                                    }}
                                                >
                                                    <GrTransaction
                                                        style={{
                                                            marginRight: "0.5rem",
                                                            color: "#3b82f6",
                                                            fontSize: "1.25rem",
                                                        }}
                                                    />
                                                    <span
                                                        style={{
                                                            fontSize: "1.125rem",
                                                            fontWeight: "bold",
                                                            color: "#333",
                                                            textTransform: "capitalize",
                                                        }}
                                                    >
                                                        {payment.tipe}
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        fontSize: "0.875rem",
                                                        color: "#666",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <FaGraduationCap
                                                        style={{ marginRight: "0.5rem", color: "#666" }}
                                                    />
                                                    {payment.statusTitle}
                                                </div>
                                            </div>
                                            <div style={{ textAlign: "right" }}>
                                                <div
                                                    style={{
                                                        fontSize: "1.125rem",
                                                        fontWeight: "900",
                                                        color: "#DF7022",
                                                    }}
                                                >
                                                    {formatRupiah(payment.nominal || 0)}
                                                </div>
                                                <div
                                                    style={{
                                                        fontSize: "0.8rem",
                                                        fontWeight: "bold",
                                                        color: "#333",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        textAlign: "center",
                                                        justifyContent: "flex-end",
                                                    }}
                                                >
                                                    <FaCalendar style={{ marginRight: "0.5rem", color: "#666" }} />
                                                    {payment.tanggal}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))
                        ) : (
                            <div style={{ textAlign: "center", color: "#999" }}>
                                Tidak ada riwayat pembayaran
                            </div>
                        )}
                    </div>
                </>
            )};
        </div>
    );
};

export default DetailRekap;